import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type DisposableTokenType = {
    access_token: string;
    expires_in?: number;
    token_type: 'Bearer' | 'Unauthorised';
};

type ExchangeTokenArgs = {
    access_token: string;
    attributes: { disposable?: boolean; user_id: string };
    scopes: string[];
};

export const exchangeToken = ({ access_token, attributes, scopes }: ExchangeTokenArgs) =>
    axios.post<DisposableTokenType>(API_URLS.AUTHENTICATE, {
        access_token,
        attributes,
        client_id: 'oCGxyq24sKTcnvsr',
        grant_type: 'exchange',
        scopes
    });
